
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.997 21.949l-1.03-1.034c-2.738-2.744-6.332-6.502-7.446-8.06-2.07-2.901-2.023-6.539.116-8.847a5.685 5.685 0 014.246-1.885 5.72 5.72 0 013.671 1.33c.154.13.301.268.441.414a5.708 5.708 0 014.116-1.743 5.704 5.704 0 014.257 1.9c2.138 2.309 2.18 5.946.095 8.835-1.314 1.823-5.639 6.238-7.438 8.052l-1.028 1.038z","fill":"currentColor"}})])
          )
        }
      }
    